import { createSelector } from 'reselect'

// Constants
import { ARCHIVE_FILE_TYPES } from 'Constants'

const getFetchingS3URLs = ({ uploadFile }) => uploadFile.fetchingS3URLs
const getUploads = ({ uploadFile }) => uploadFile.uploads

const isArchive = (mimeType) => {
  return ARCHIVE_FILE_TYPES.includes(mimeType)
}

const getItemError = (item, failures) => {
  if (isArchive(item.file.type)) {
    return failures?.length ? 'UPLOAD_FAILURES' : undefined
  }
  return 'error' in item ? item.error || 'UPLOAD_FAILED' : undefined
}

const fileUploadSelectors = {
  getFetchingS3URLs: createSelector([getFetchingS3URLs], (fetchingS3URLs) => {
    return fetchingS3URLs
  }),

  getUploads: createSelector([getUploads], (uploads) => {
    if (!Object.keys(uploads).length) {
      return []
    }

    return Object.values(uploads).map(({ failures, successes, ...item }) => {
      const mappedFailures = (failures || []).map((failure) => {
        return { ...failure, error: failure.error || 'UPLOAD_FAILED' }
      })
      const children = [...mappedFailures, ...(successes || [])]
      const isArchiveFile = ARCHIVE_FILE_TYPES.includes(item.meta.contentType)
      const hasChildErrors = Boolean(isArchiveFile && mappedFailures.length)

      return {
        ...item,
        children: isArchiveFile ? children : [],
        childErrors: hasChildErrors,
        error: getItemError(item, failures),
      }
    })
  }),
}

export default fileUploadSelectors
